<div class="cc-icon cc-icon-spinner-fw"></div>

<h1 class="sm-text-xl sm-font-bold" i18n>Redirecting...</h1>

<p class="sm-text-center sm-text-sm" i18n>
  {{ message }}
</p>
